import { render } from "./PatientDetails.vue?vue&type=template&id=311cf23f&ts=true"
import script from "./PatientDetails.vue?vue&type=script&lang=ts"
export * from "./PatientDetails.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__